module.exports = __webpack_public_path__ + "static/no-js-b5c0550e13a5e312413eb0ff50d6c6bd.png";